import PayoutsIncomeChartWidget from './PayoutsIncomeChartWidget';

export default PayoutsIncomeChartWidget;
